export const APP_NAME: string = process.env.APP_NAME || 'hsm-admin';

export const LOGIN_URL: string =
  process.env.LOGIN_URL || 'https://www.login.stagecliengo.com';

export const APPSMITH_APP_URL: string = process.env.APPSMITH_APP_URL || '';
